module.exports = __webpack_public_path__ + "img/s3.d70f65ca.svg";